import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROCOUPONS_ITEM(state, euroCouponsItem) {
    state.cached = euroCouponsItem
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEuroCouponsItem(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/items/${payload.query}`, payload.type).then((response) => {
      if (payload.type) {
        return response
      }
      const request = response.data
      context.commit('EUROCOUPONS_ITEM', request)
      return request
      
      
    })
  },

  fetchEuroCouponsItemOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/items/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsItemDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateEuroCouponsItem(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/euro_coupons/items/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteEuroCouponsItem(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}